import React from 'react';
import PageSeo from '@/seo/PageSeo';
import { sendGAPageview } from '../utils/gaConsent';
import SupportContent from '../components/Support/SupportContent';
import $ from 'jquery';

export default function Support() {
  $('.popover').hide();
  sendGAPageview({ hitType: 'pageview', page: '/Support', title: 'Contact' });

  return (
    <React.Fragment>
      <PageSeo
        title="Support and Contact | DISGENET"
        description="Contact DISGENET support for licensing, academic access and help using the gene-disease association database."
        path="/Support"
      />
      <SupportContent />
    </React.Fragment>
  );
}
